import { render } from "./ConcessionRequest.vue?vue&type=template&id=6bb3a644&scoped=true"
import script from "./ConcessionRequest.vue?vue&type=script&lang=js"
export * from "./ConcessionRequest.vue?vue&type=script&lang=js"

import "./ConcessionRequest.vue?vue&type=style&index=0&id=6bb3a644&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb3a644"]])

export default __exports__